export const MODAL_CONTENT_STRESS = {
  MCV: `
La méthode se résume par le <b>365 :</b>

- <b>3</b> fois par jour, <b>6</b> respirations par minute, pendant <b>5</b> minutes
- Il suffit d'<b>inspirer sur 5 secondes</b> et <b>expirer sur 5 secondes</b> (en comptant lentement jusqu’à 5)
- La méthode peut se pratiquer assis ou debout, mais pas couché
`,
  PHYSICAL_ACTIVITY_RECO: `
<b>L’OMS recommande une activité physique régulière</b> qui améliore le bien-être général et réduit les symptômes de dépression et d’anxiété. Pour un adulte, il est recommandé :

- De pratiquer par semaine <b>au moins 2h30</b> d’une activité physique <b>d’intensité modérée</b>
- Ou au moins <b>75 minutes hebdomadaires</b> d’une activité physique <b>intense</b>
- <b>D’inclure des activités de renforcement musculaire</b> mettant en jeu les principaux groupes de muscles, à pratiquer <b>deux jours par semaine ou plus</b>
`,

  GROUNDING_EXERCISE: `
<b>Vous pouvez donner les instructions suivantes au participant :</b>

- Les pieds ancrés dans le sol et le dos droit. Fermer les yeux et <b>penser à une sensation physique que vous êtes en train de ressentir</b>. Se concentrer sur cette sensation pendant quelques secondes
- Ouvrir les yeux et essayer d'<b>observer 5 choses différentes dans la pièce</b>. Laisser s’écouler quelques secondes
- Fermer de nouveau les yeux et essayer d'<b>entendre 5 bruits différents</b> dans la pièce. Laisser s’écouler quelques secondes
- <b>Laisser les pensées venir et repartir</b>, en avoir conscience, ne pas les bloquer mais ne pas s'attarder dessus
- Après quelques secondes, ouvrir les yeux et reprendre connaissance de son environnement
`,

  SELF_MASSAGE: `
<b>Vous pouvez donner les instructions suivantes au participant :</b>

- Se masser la tête, le cuir chevelu
- Déplacer la peau d'avant en arrière, d'un côté à l'autre
- Se masser la nuque, le cou, les épaules
- Se masser en faisant de petits cercles avec trois doigts
- Se faire un shampoing imaginaire
`,

  EATING_HABITS: `
<b>Conseils alimentaires :</b>

- Prendre le repas à des <b>horaires réguliers</b>
- Prendre <b>3 repas par jour</b> et éviter de sauter des repas
- À chaque repas, <b>manger ni trop ni trop peu</b> afin d’éviter la sensation de "trop plein" après le repas ou au contraire la sensation de faim entre deux repas
- <b>Manger lentement, au calme, sans faire une autre activité simultanément</b> (par exemple travailler sur un ordinateur) — minimum 30 minutes
- Penser à bien <b>mastiquer</b> les aliments pour en faciliter la digestion
- Lors des repas et en dehors, <b>boire 1 à 1,5 litre d'eau chaque jour</b> pour bien s’hydrater
`,

  SLEEP_HYGIENE: `
<b>Bien préparer son sommeil</b>

- Éviter les excitants en fin de journée
- Éviter l'alcool et les repas copieux et gras au dîner
- <b>Ne pas pratiquer une activité stimulante après 19 heures</b> (écrans, téléphone, internet…)
- Faire de l'<b>exercice physique dans la journée</b>, mais éviter après 17 h
- Favoriser les <b>activités relaxantes</b> (lecture, musique douce) en fin de journée
- <b>Limiter le temps devant les écrans</b>, surtout le soir (pas après 21h30)
- <b>Éviter les siestes longues</b> (> 1h) ou trop tardives (après 16h)
- <b>Éviter les conflits</b> en fin de journée
- <b>Ne pas prendre de bain chaud avant le coucher</b> (augmente la température corporelle)

<b>À l'heure de se coucher</b>

- Respecter des horaires <b>réguliers de sommeil</b> (même le week-end)
- <b>Ne pas résister à l'endormissement</b> : aller dormir dès les premiers signes de fatigue
- Éviter les écrans, le travail ou les repas au lit : <b>réserver la chambre au sommeil</b>
- <b>Dormir selon ses besoins</b>, mais pas plus

<b>Un environnement frais et calme</b>

- <b>Limiter le bruit et la lumière</b> (volets / rideaux fermés)
- Ne pas chauffer la chambre au-delà de <b>18°C - 19°C</b>
- Vérifier la qualité de sa literie
`,

  BREATHING_478: `
La <b>respiration 4-7-8</b> est un exercice simple, praticable partout :

- <b>Inspirer</b> en comptant jusqu’à 4
- <b>Retenir</b> son souffle en comptant jusqu’à 7
- <b>Expirer</b> en comptant jusqu’à 8

Ce cycle doit être répété <b>4 fois, 2 fois par jour</b>
`,
};
